export enum ConfigFileStatus {
	draft = 0,
	production = 1,
}

export type ConfigFileStatusType = ConfigFileStatus;
